/**
 * Shared types for the WebSocket layer (connection, task events, user events).
 * Mirrors the server contract in backend/app/websocket/events.py.
 */

export type ConnectionState =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'reconnecting';

export interface TaskProgress {
  taskId: string;
  stage: string;
  progress: number;
  message: string;
  metadata?: Record<string, any>;
  isComplete: boolean;
  /** Static English error text (fallback when no errorCode is present). */
  error?: string;
  /** Stable job error code (background_jobs.ERROR_*), when the server knows it. */
  errorCode?: string;
  /** i18n key for errorCode (`jobs.errors.<code>`). */
  errorMessageKey?: string;
  result?: Record<string, any>;
  /** True when no progress or heartbeat received for STALL_TIMEOUT_MS */
  mayBeStalled?: boolean;
  /** Accumulated streaming text */
  streamingText?: string;
  /** Whether currently streaming */
  isStreaming?: boolean;
  /** Last received sequence number */
  streamSeq?: number;
  /** Message ID from stream_end */
  streamMessageId?: number;
  /** Stream error message */
  streamError?: string;
}

export interface CreditUpdateEvent {
  action: string; // 'purchase_complete' | 'purchase_failed'
  creditsAdded?: number;
  packId?: string;
  error?: string;
  timestamp: number;
}

export interface NotificationEvent {
  id: number;
  notification_type: string;
  title: string;
  body?: string;
  sender_name?: string;
  resource_type?: string;
  resource_id?: number;
  created_at: string;
}

export interface WebSocketMessage {
  type: string;
  task_id?: string;
  payload?: any;
  message?: string;
  data?: any;
}

const WS_DEBUG = process.env.EXPO_PUBLIC_DEBUG_WS === 'true';

export const logDebug = (...args: any[]) => {
  if (WS_DEBUG) {
    console.log(...args);
  }
};

export const warnDebug = (...args: any[]) => {
  if (WS_DEBUG) {
    console.warn(...args);
  }
};
